<template>
  <tabs
    :tabs="tabs"
    :selectedTab="selectedTab"
    :showing="showing"
    :bgClass="'bg-white'"
    :borderClass="'border-color-light-gray bordered-tab-item'"
    :itemTextClass="'color-custom-dark-grey'"
    :itemBGClass="'bg-dark-gray'"
    @select-tab="selectTab"
    @remove-tab="removeTab"
    @update-tab="updateTab"
    @add-tab="addTab"
  />
</template>

<script>
import ReportsIndex from "./ReportsIndex.vue";
import Tabs from "../workspace/Tabs.vue";

export default {
  name: "ReportTabs",
  components: { Tabs },
  props: ["showing"],
  data: () => ({
    tabs: [
      {
        key: "list",
        text: "All Reports",
        component: ReportsIndex,
        props: {},
        closeable: false
      }
    ],
    selectedTab: "list"
  }),
  methods: {
    selectTab(selectedTab) {
      this.selectedTab = selectedTab;
    },
    removeTab(tabIndex) {
      if (this.tabs[tabIndex].key == this.selectedTab) {
        if (tabIndex < this.tabs.length - 1) {
          this.selectedTab = this.tabs[tabIndex + 1].key;
        } else {
          this.selectedTab = this.tabs[tabIndex - 1].key;
        }
      }
      const newTabs = [...this.tabs];
      newTabs.splice(tabIndex, 1);
      this.tabs = newTabs;
    },
    addTab(tab) {
      if (this.tabs.map(tab => tab.key).indexOf(tab.key) === -1) {
        const newTabs = [...this.tabs];
        newTabs.push(tab);
        this.tabs = newTabs;
      }
      this.selectTab(tab.key);
    },
    updateTab({ tabIndex, data }) {
      const newTabs = [...this.tabs];
      newTabs[tabIndex] = {
        ...newTabs[tabIndex],
        ...data
      };
      if (this.tabs.map(t => t.key).indexOf(this.selectedTab) == tabIndex)
        this.selectedTab = newTabs[tabIndex].key;
      this.tabs = newTabs;
    }
  }
};
</script>
